import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as e from 'express';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { environment } from 'src/environments/environment';

interface resGetDetailCourseById {
  message: string,
  result: [
    {
      COURSE_DESCRIPTION: string,
      COURSE_ID: string,
      COURSE_NAME: string,
      COURSE_PRICE: number,
      COURSE_VDO_EXAMPLE: string,
      COURSE_END: string,
      DETAIL_COURSE: [
        {
          LESSON_ID: string,
          LESSON_NAME: string,
          LESSON_DOC: string,
          LESSON_DOC_ORIGINAL: string,
          DETAIL_COURSE: [
            {
              TOPIC_ID: string,
              TOPIC_NAME: number,
              TOPIC_TYPE: string,
              TOPIC_LINE: number,
              TOPIC_COMPLETE: boolean
            },
          ]
        }
      ]
      IS_FAVORITE: boolean,
      IS_PROMISE: boolean,
    }
  ],
  success: boolean,
}

interface resGetAllReviewByCourseId {
  message: string,
  result: {
    POINT: {
      AVERAGE_POINT: number,
      MAX_POINT: number,
      TOTAL_REVIEW: number,
    }
    CAN_POST: boolean,
    REVIEW_LIST: [
      {
        IMAGE_PROFILE: string,
        REVIEW_DATE: string,
        REVIEW_ID: string,
        REVIEW_MESSAGE: string,
        REVIEW_POINT: number,
        USERNAME: string,
      }
    ]
  }
  success: boolean,
}

interface resGetChatByCourseId {
  message: string,
  result: {
    COURSE_NAME: string,
    respon: [
      {
        CHAT_ID: string,
        CHAT_MESSAGE: string,
        CHAT_NUMBER: number,
        CHAT_USERNAME: string,
        CHAT_USER_ID: string,
        CREATE_DATE: Date;
        PROFILE_PIC: string,
        SUB_CHAT: [
          {
            CHAT_ID: string,
            CHAT_MESSAGE: string,
            CHAT_NUMBER: string,
            CHAT_USERNAME: string,
            CHAT_USER_ID: string,
            PROFILE_PIC: string,
          }
        ]
      }
    ]
  }
  success: boolean,
}

interface resCreateReviewByCourseId {
  message: string,
  result: {
    REVIEW_ID: string,
  }
  success: boolean,
}

interface resGetProgressCourseId {
  message: string,
  result: {
    COURSE_COIN_REWARD: number,
    FIRST_COMPLETE: boolean,
    PROGRESS: number,
  }
  success: boolean,
}

interface resCreateChatByCourseId {
  message: string,
  result: string,
  success: boolean,
}

interface resGetDetailTopicCourseAssignment {
  message: string,
  result: [
    {
      ASSIGNMENT_FILE: string,
      ASSIGNMENT_FILE_NAME: string,
      FEEDBACK: [
        {
          FEEDBACK_DATE: string,
          FEEDBACK_DOC: string,
          FEEDBACK_DOC_ORIGINAL: string,
          FEEDBACK_ID: string,
          FEEDBACK_MESSAGE: string,
        }
      ]
      TIME_SHOW: number,
      TOPIC_ID: string,
      TOPIC_LINE: number,
      TOPIC_NAME: string,
    }
  ];
  success: boolean,
}

interface resGetDetailTopicCourseVideo {
  message: string,
  result: [
    {
      HASH_KEY: string,
      ORIGINAL_NAME_VDO: string,
      TOPIC_ID: string,
      TOPIC_LINE: number,
      TOPIC_NAME: string,
      VIDEO_LINK: string,
      VIDEO_THUMNAL: string,
      VIDEO_THUMNAL_ORIGINAL: string,
    }
  ];
  success: boolean,
}

interface resGetDetailTopicCourseQuiz {
  message: string,
  result: [
    {
      PASSOFQUIZ: number,
      TIME_QUIZ_AGAIN: number,
      TOPIC_ID: string,
      TOPIC_LINE: number,
      TOPIC_NAME: string,
      VALUE: [
        {
          QUESTION: string,
          VALUE:
          [
            {
              ID_TRANS: number,
              OPTION_ID: number,
              OPTION_NAME: string,
              OPTION_NUMBER: number,
              OPTION_PIC: string,
              OPTION_PIC_ORIGINAL: string,
            }
          ]
        }
      ]
    }
  ];
  success: boolean,
}

interface resSendAnswer {
  message: string,
  result:
  {
    POINTOfPASS: number,
    POINT_MAX: number,
    QUIZ_PASS: boolean,
    YOURPOINT: number,
    DATE_QUIZ_AGAIN: string,
  }
  success: boolean,
}

export interface resGetAllCourse {
  message: string,
  result: [
    {
      COURSE_ID: string,
      COURSE_NAME: string,
      COURSE_PIC: string,
      COURSE_PRICE: number,
      COURSE_SPECIALPRICE: number,
      USERNAME: string,
    }
  ]
  success: boolean,
}

interface resCreateFeedBackByUser {
  message: string,
  result:
  {
    FEEDBACK_ID: string,
  }
  success: boolean,
}

interface resFavoriteCourse {
  message: string,
  result:
  {
    update: string,
  }
  success: boolean,
}

interface resUpdateStatusLessonTopic {
  message: string,
  result:
  {
    updatetime: string,
  }
  success: boolean,
}

interface resGetCertificateByCourse {
  message: string,
  success: boolean,
  result: {
    USERNAME: string,
    COURSE_NAME: string,
    LEARN_FROM: string,
    LEARN_TO: string
  }
}

interface resGetDetailTopicCourseMeasure {
  message: string,
  success: boolean,
  result: {
    LINK: string,
    TOPIC_ID: string
  }
}

interface resGetPrivateChat {
  message: string,
  success: boolean,
  result: [
    {
      ID: number,
      CHAT_ID: number,
      ADMIN_ID: string,
      USER_ID: string,
      MESSAGE_TYPE: string,
      MESSAGE: string
      FILE_NAME: string,
      CREATE_DATE: string,
      USER_TYPE: string
    }
  ]
}

interface resPostPrivateChat {
  message: string,
  success: boolean,
}

@Injectable({
  providedIn: 'root'
})
export class ELearningService {
  token: string;

  constructor(
    private http: HttpClient,
    private authService: AuthService
  ) {
    this.authService.token.subscribe(res => this.token = res ? res : environment.KEY);
  }

  getDetailCourseById(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetDetailCourseById>(environment.URL + '/course/getDetailCourseById?COURSE_ID=' + id, { headers: headers });
  }

  getAllReviewByCourseId(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllReviewByCourseId>(environment.URL + '/review/getAllReviewByCourseId?COURSE_ID=' + id, { headers: headers });
  }

  getChatByCourseId(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetChatByCourseId>(environment.URL + '/chat/getChatByCourseId?COURSE_ID=' + id, { headers: headers });
  }

  createReviewByCourseId(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateReviewByCourseId>(environment.URL + '/review/createReviewByCourseId', body, { headers: headers });
  }

  createChatByCourseId(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resCreateChatByCourseId>(environment.URL + '/chat/createChatByCourseId', body, { headers: headers });
  }

  getProgressCourseId(id) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetProgressCourseId>(environment.URL + '/course/getProgressCourseId?COURSE_ID=' + id, { headers: headers });
  }

  getDetailTopicCourseVideo(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTopicCourseVideo>(environment.URL + '/course/getDetailTopicCourse', body, { headers: headers });
  }

  getDetailTopicCourseQuiz(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTopicCourseQuiz>(environment.URL + '/course/getDetailTopicCourse', body, { headers: headers });
  }

  getDetailTopicCourseAssignment(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTopicCourseAssignment>(environment.URL + '/course/getDetailTopicCourse', body, { headers: headers });
    // } else if (body.TOPIC_TYPE === 'Measure') {
    //   return this.http.post(environment.URL + '/course/getDetailTopicCourse', body, { headers: headers });
  }

  getDetailTopicCourseMeasure(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resGetDetailTopicCourseMeasure>(environment.URL + '/course/getDetailTopicCourse', body, { headers: headers });
  }

  sendAnswer(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resSendAnswer>(environment.URL + '/course/sendAnswer', body, { headers: headers });
  }

  getAllCourse(selectedType) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetAllCourse>(environment.URL + '/course/getAllCourse?TYPE=' + selectedType, { headers: headers });
  }

  createFeedBackByUser(body) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    formData.append('FEEDBACK_DOC', body.FEEDBACK_DOC);
    formData.append('ASSIGNMENT_ID', body.ASSIGNMENT_ID);

    return this.http.post<resCreateFeedBackByUser>(environment.URL + '/course/createFeedBackByUser', formData, { headers: headers });
  }

  favoriteCourse(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resFavoriteCourse>(environment.URL + '/course/favoriteCourse', body, { headers: headers });
  }

  updateStatusLessonTopic(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post<resUpdateStatusLessonTopic>(environment.URL + '/course/updateStatusLessonTopic', body, { headers: headers });
  }

  getCertificateByCourse(cid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetCertificateByCourse>(environment.URL + '/course/getCertificateByCourse?COURSE_ID=' + cid, { headers: headers });
  }

  createCertificateByCourse(body) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.post(environment.URL + '/course/createCertificateByCourse', body, { headers: headers });
  }

  postPrivateChat(form, body, cid) {
    const headers = new HttpHeaders({ Authorization: this.token })
    let formData = new FormData;

    for (let i = 0; i < form.file.fileList?.length; i++) {
      formData.append('IMAGE', form.file.fileList[i].originFileObj);
    }

    formData.append('COURSE_ID', cid);
    formData.append('CHAT_DATA', JSON.stringify(body));

    return this.http.post<resPostPrivateChat>(environment.URL + '/course/postPrivateChat', formData, { headers: headers });
  }

  getPrivateChat(cid) {
    const headers = new HttpHeaders({ Authorization: this.token })

    return this.http.get<resGetPrivateChat>(environment.URL + '/course/getPrivateChat?COURSE_ID=' + cid, { headers: headers });
  }
}
